import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

// Components
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
// Assets
import LogoIcon from "../../assets/svg/Logo";
import BurgerIcon from "../../assets/svg/BurgerIcon";
import logo from "../../assets/img/logo.png";

export default function TopNavbar() {
  const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => setY(window.scrollY));
    return () => {
      window.removeEventListener("scroll", () => setY(window.scrollY));
    };
  }, [y]);

  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <Wrapper
        className="flexCenter animate whiteBg"
        style={y > 100 ? { height: "60px" } : { height: "80px" }}
      >
        <NavInner className="container flexSpaceCenter">
          <Link className="pointer flexNullCenter" to="/" smooth={true}>
            <LogoWrapper>
              <img src={logo} alt="PakMaidService Logo" loading="lazy" />
              <h1 style={{ fontSize: "1.4rem" }}>PakMaidService</h1>
            </LogoWrapper>
          </Link>
          <BurderWrapper
            className="pointer"
            onClick={() => toggleSidebar(!sidebarOpen)}
          >
            <BurgerIcon />
          </BurderWrapper>
          <UlWrapper className="flexNullCenter">
            <li className="semiBold font20 pointer">
              <Link
                to="/"
                activeClass="active"
                style={{ padding: "10px 15px" }}
              >
                Home
              </Link>
            </li>
            <li className="semiBold font20 pointer">
              <Link
                to="/services"
                activeClass="active"
                style={{ padding: "10px 15px" }}
              >
                Services
              </Link>
            </li>
            <li className="semiBold font20 pointer">
              <Link
                to="/about"
                activeClass="active"
                style={{ padding: "10px 15px" }}
              >
                About Us
              </Link>
            </li>
            <li className="semiBold font20 pointer">
              <Link
                to="/contact"
                activeClass="active"
                style={{ padding: "10px 15px" }}
              >
                Get in Touch
              </Link>
            </li>
          </UlWrapper>
        </NavInner>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
`;
const NavInner = styled.div`
  position: relative;
  height: 100%;
`;
const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;

  img {
    height: auto;
    width: 100px;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    img {
      height: 130px;
    }
  }
`;
const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  display: none;
  @media (max-width: 760px) {
    display: block;
  }
`;
const UlWrapper = styled.ul`
  display: flex;
  @media (max-width: 760px) {
    display: none;
  }
`;
const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;
